import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";
import { Knob } from "react-rotary-knob";

//assets
import modalBackground from "assets/images/login.png";
import knobSkin from "assets/knobSkins/frequencyKnob";
import * as skins from "react-rotary-knob-skin-pack";
import skin12 from "assets/knobSkins/skin12";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Button, Grid, Typography } from "@material-ui/core";


import { useLogin } from 'hooks/auth';

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "relative",
    top: 0,
    left: 0,
    bottom: 0,
    top: 0,
    width: "100%",
    height: "100%",
    maxHeight: "1185px",
    maxWidth: "626px",
    backgroundImage: `url(${modalBackground})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left bottom",
    overflow: "hidden",
    justifyContent: "center",
    textAlign: "center",
  },
  frequencyKnobSkin: {
    display: "inline-block",
    width: "100%",
  },
  passwordPartDiv: {
    background: "white",
    
  },
  activePasswordPartDiv: {
    border: "2px dashed #64B395",
  },
  filledPasswordPartDiv: {
    border: "2px solid #DDFFDD",
    // backgroundPosition: 'left',
    background: 'linear-gradient(to right, #DDFFDD 50%, white 0)',
    backgroundSize: '200% 100%',
    backgroundPosition: 'right',
    animation: 'makeItfadeIn 500ms 0s forwards'
    
  },
}));

/**
 * @component LoginModal
 */
function LoginModal() {
  const classes = useStyles();
  const { mutate, isLoading } = useLogin();


  const onSubmit = (data) => {
      let password = passwordDirection1+passwordPart1+passwordDirection2+passwordPart2+passwordDirection3+passwordPart3+passwordDirection4+passwordPart4
      console.log("frequency is:",frequency.toFixed(0))
      console.log("passwordIs:",password)

    mutate({username:frequency.toFixed(0),password}, {
      onSuccess: (response) => {
        if (response) {
          console.log(response)
        //   setAuthCookie({ ...response });
        }
      },
    });
  };


  const [frequency, setFrequency] = useState(0);
  const [knobValue, setKnobValue] = useState(0);
  const [passwordKnobValue, setPasswordKnobValue] = useState(0);

  const [lastRotateDirection, setLastRotateDirection] = useState("");

  const [passwordPart1, setPasswordPart1] = useState(0);
  const [passwordPart2, setPasswordPart2] = useState(0);
  const [passwordPart3, setPasswordPart3] = useState(0);
  const [passwordPart4, setPasswordPart4] = useState(0);

  const [passwordDirection1, setPasswordDirection1] = useState("");
  const [passwordDirection2, setPasswordDirection2] = useState("");
  const [passwordDirection3, setPasswordDirection3] = useState("");
  const [passwordDirection4, setPasswordDirection4] = useState("");

  const passwordPartSetters = [
    setPasswordPart1,
    setPasswordPart2,
    setPasswordPart3,
    setPasswordPart4,
  ];
  const passwordDirectionSetters = [
    setPasswordDirection1,
    setPasswordDirection2,
    setPasswordDirection3,
    setPasswordDirection4,
  ];
  const iconMap = {
    left: <RotateLeftIcon />,
    right: <RotateRightIcon />,
    "": <QuestionMarkIcon />,
  };

  const [passwordInsertionIndex, setPasswordInsertionIndex] = useState(0);

  const [lastDirections, setLastDirections] = useState([]);
  const [lastDirectionValues, setLastDirectionValues] = useState([]);

  useEffect(() => {}, []);

  return (
    <Grid container direction="column" className={classes.modalContainer}>
      <Grid
        item
        style={{
          //   position: "relative",
          //   left: "25%",
          //   top: "25%",
          width: "100%",
          height: "25%",
        }}
      >
        <Knob
          className={classes.frequencyKnobSkin}
          style={{ width: "25%", height: "auto", position: "relative" }}
          skin={knobSkin}
          min={0}
          max={360}
          step={1}
          value={knobValue}
          unlockDistance={50}
          // clampMin={0}
          // clampMax={150}
          // rotateDegrees={-50}
          onChange={(value) => {
            // setKnobValue(value)
            let rotateDirection = knobValue > value ? -1 : 1;
            let diff = Math.abs(value - knobValue);
            // console.log(diff)
            if (diff < 50)
              setFrequency((frequency) =>
                Math.max(
                  0,
                  Math.min(
                    10000000,
                    frequency + (rotateDirection * Math.pow(diff, 4)) / 5
                  )
                )
              );
            setKnobValue(value);
          }}
        />
        <p
          style={{
            position: "relative",
            top: "-50%",
            // left: "35%",
            color: "black",
          }}
        >
          {frequency.toFixed(0)}
        </p>
      </Grid>

      <Grid
        item
        style={{
          //   position: "relative",
          //   left: "25%",
          //   top: "25%",
          width: "100%",
          height: "30%",
        }}
      >
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid item xs={12} md={4}>
            {/* <Typography variant="h5">Combination</Typography> */}
          </Grid>
          <Grid item xs={12}>
            <Knob
              className={classes.frequencyKnobSkin}
              style={{ width: "25%", height: "auto", position: "relative" }}
              skin={skins.s12}
              min={0}
              max={100}
              step={1}
              value={passwordKnobValue}
              unlockDistance={50}
              // clampMin={0}
              // clampMax={150}
              // rotateDegrees={-50}
              onChange={(value) => {
                  if(passwordInsertionIndex>4) return
                // setKnobValue(value)
                let rotateDirection =
                  passwordKnobValue > value ? "left" : "right";

                lastDirections.push(rotateDirection);
                lastDirectionValues.push(value);

                if (lastDirections.length > 10) {
                  lastDirections.shift();
                  lastDirectionValues.shift();
                }

                let diff = Math.abs(passwordKnobValue - value);

                // console.log(diff)

                if (
                  rotateDirection !== lastRotateDirection &&
                  lastDirections.length >= 4 &&
                  lastDirections.every(
                    (direction) => direction === lastDirections[0]
                  )
                ) {
                  console.log(diff);
                  if (passwordInsertionIndex < 4)
                    passwordDirectionSetters[passwordInsertionIndex](
                      rotateDirection
                    );
                  setLastRotateDirection(rotateDirection);
                  if (passwordInsertionIndex > 0) {
                    passwordPartSetters[passwordInsertionIndex - 1](
                      lastDirectionValues[0].toFixed(0)
                    );
                  }
                  setPasswordInsertionIndex(
                    (passwordInsertionIndex) => passwordInsertionIndex + 1
                  );
                }

                setPasswordKnobValue(value);
              }}
            />
          </Grid>

          <Grid
            item
            xs={3}
            md={2}
            className={`${classes.passwordPartDiv} ${
              passwordInsertionIndex < 2 && classes.activePasswordPartDiv
            } ${passwordInsertionIndex >= 2 && classes.filledPasswordPartDiv}`}
          >
            <Grid container direction="column">
              <Grid item style={{ heigth: "40%" }}>
                {iconMap[passwordDirection1]}
              </Grid>
              <Grid item style={{ heigth: "60%" }}>
                {passwordPart1}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={3}
            md={2}
            className={`${classes.passwordPartDiv} ${
                passwordInsertionIndex == 2 && classes.activePasswordPartDiv
              } ${passwordInsertionIndex > 2 && classes.filledPasswordPartDiv}`}
          >
            <Grid container direction="column">
              <Grid item style={{ heigth: "40%" }}>
                {iconMap[passwordDirection2]}
              </Grid>
              <Grid item style={{ heigth: "60%" }}>
                {passwordPart2}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={3}
            md={2}
            className={`${classes.passwordPartDiv} ${
                passwordInsertionIndex == 3 && classes.activePasswordPartDiv
              } ${passwordInsertionIndex > 3 && classes.filledPasswordPartDiv}`}
          >
            <Grid container direction="column">
              <Grid item style={{ heigth: "40%" }}>
                {iconMap[passwordDirection3]}
              </Grid>
              <Grid item style={{ heigth: "60%" }}>
                {passwordPart3}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={3}
            md={2}
            className={`${classes.passwordPartDiv} ${
                passwordInsertionIndex == 4 && classes.activePasswordPartDiv
              } ${passwordInsertionIndex > 4 && classes.filledPasswordPartDiv}`}
          >
            <Grid container direction="column">
              <Grid item style={{ heigth: "40%" }}>
                {iconMap[passwordDirection4]}
              </Grid>
              <Grid item style={{ heigth: "60%" }}>
                {passwordPart4}
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={6} style={{height:"25%",background:"blue",marginTop:"10px"}}>
              <Button variant="contained" onClick={()=>{
                  passwordPartSetters[passwordInsertionIndex - 2](0)
                //   passwordDirectionSetters[passwordInsertionIndex-2]("")
                  passwordDirectionSetters[passwordInsertionIndex-1]("")
                  lastDirections.length=0
                  lastDirectionValues.length=0
                  setLastRotateDirection(lastRotateDirection=>lastRotateDirection==="right"?"left":"right");
                  setPasswordInsertionIndex(passwordInsertionIndex=>Math.max(0,passwordInsertionIndex-1))

              }}>
                  Erase
              </Button>
              <Button variant="contained" onClick={onSubmit}>
                  Confirm
              </Button>
          </Grid>


        </Grid>
      </Grid>
    </Grid>
  );
}

export default LoginModal;
